// « Ce qui va avec » (snippets/snk-complements.liquid) : sans liste réglée, charge les recommandations complémentaires
// de Shopify (sections/snk-complements.liquid) ; retire une ligne dès que son produit entre au panier (événement
// cartUpdate publié par snk-card.js ou product-form.js), et cache le bloc quand il ne reste rien.
if (!customElements.get('snk-complements')) {
  customElements.define(
    'snk-complements',
    class SnkComplements extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('data-recommend') && !this.querySelector('.snk-comp__row')) this.recommend();
        else this.check();

        // Flèches : une carte de plus ou de moins ; désactivées au début et à la fin de la piste
        this.rows = this.querySelector('[data-snk-comp-rows]');
        this.prev = this.querySelector('[data-snk-comp-prev]');
        this.next = this.querySelector('[data-snk-comp-next]');
        const step = (direction) => {
          const card = this.rows.querySelector('.snk-comp__row');
          if (!card) return;
          const gap = parseFloat(getComputedStyle(this.rows).columnGap) || 0;
          this.rows.scrollBy({ left: direction * (card.offsetWidth + gap), behavior: 'smooth' });
        };
        this.prev?.addEventListener('click', () => step(-1));
        this.next?.addEventListener('click', () => step(1));
        this.rows?.addEventListener('scroll', () => requestAnimationFrame(() => this.updateArrows()), { passive: true });
        if ('ResizeObserver' in window && this.rows) new ResizeObserver(() => this.updateArrows()).observe(this.rows);
        this.updateArrows();

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            const productId = event?.cartData?.product_id;
            if (!productId) return;
            const rows = this.querySelectorAll(`.snk-comp__row[data-product-id="${productId}"]`);
            if (!rows.length) return;
            // Le temps du « ✓ Ajouté » de snk-card, puis la ligne s'efface
            setTimeout(() => {
              rows.forEach((row) => row.remove());
              this.check();
            }, 1200);
          });
        }
      }

      disconnectedCallback() {
        this.unsubscribe?.();
      }

      check() {
        this.hidden = !this.querySelector('.snk-comp__row');
        this.updateArrows?.();
      }

      updateArrows() {
        if (!this.rows || !this.prev || !this.next) return;
        const { scrollLeft, scrollWidth, clientWidth } = this.rows;
        const scrollable = scrollWidth > clientWidth + 2;
        this.prev.closest('.snk-comp__arrows').hidden = !scrollable;
        this.prev.disabled = scrollLeft <= 2;
        this.next.disabled = scrollLeft + clientWidth >= scrollWidth - 2;
      }

      async recommend() {
        try {
          const response = await fetch(this.dataset.recommendUrl);
          if (!response.ok) throw new Error(response.status);
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const rows = doc.querySelector('[data-snk-comp-rows]');
          if (rows?.children.length) this.querySelector('[data-snk-comp-rows]').replaceChildren(...rows.children);
        } catch (error) {
          // Pas de recommandation : le bloc disparaît
        }
        this.removeAttribute('data-recommend');
        this.check();
      }
    }
  );
}
